import { ProductFeedbackPortable } from "@3gaam/api/types/consultancy";
import { TextAreaField } from "@3gaam/shared/components/general/form";
import { Space } from "@3gaam/shared/components/general/space";
import { useState } from "react";
import { Avatar } from "../../../components/general/avatar";
import { StarRating } from "../StarRating";

export const RatingForm = ({
  onDismiss,
  onSubmit,
  productFeedback,
  rateUserProductRequesting,
}: {
  onDismiss: () => void;
  onSubmit: ({
    rate,
    comment,
  }: {
    rate: number;
    comment: string | undefined;
  }) => void;
  productFeedback: ProductFeedbackPortable;
  rateUserProductRequesting: boolean;
}) => {
  const [textAreaValue, setTextAreaValue] = useState<string>("");
  const [ratingValue, setRatingValue] = useState<number | undefined>(undefined);

  let counselor = productFeedback.Counselor;

  return (
    <>
      <div className="px-3 d-flex flex-column align-items-center h-100 justify-content-around">
        <div className="d-flex flex-column align-items-center text-center ">
          <Avatar
            size={120}
            borderRadius={120}
            src={counselor?.Avatar}
            alt={counselor?.Name}
          />
          <Space vertical={16} />
          <span className="font-20 text-dark-gray font-weight-medium">
            {counselor?.Name}
          </span>
          <p className="font-16 text-gray3 font-weight-light">
            {productFeedback.Product}
          </p>
        </div>
        <div>
          <span className="font-16 text-gray3 font-weight-regular">
            {productFeedback.Question}
          </span>
          <div className="d-flex justify-content-center mt-4">
            {
              <StarRating
                rate={ratingValue}
                onClick={(value) => {
                  setRatingValue(value / 20);
                }}
              />
            }
          </div>
        </div>

        <div className="w-100 mt-4">
          <span className="text-dark-gray font-16"> نظر شما</span>

          <TextAreaField
            className="mt-2 py-2 font-12"
            placeholder="در صورت تمایل تجربه خود را با ما به اشتراک بگذارید"
            onChange={(e) => {
              setTextAreaValue(e.target.value);
            }}
            value={textAreaValue}
          />
        </div>
      </div>
      <div className="p-3">
        <button
          type="submit"
          className={`btn btn-primary w-100 font-18 `}
          onClick={() => {
            if (typeof ratingValue === "undefined") return;
            onSubmit({ rate: ratingValue, comment: textAreaValue });
          }}
          disabled={
            typeof ratingValue === "undefined" || rateUserProductRequesting
          }
        >
          ثبت نظر
        </button>
        <Space vertical={8} />
        <button
          className="btn btn-link text-primary text-center d-block m-auto font-18"
          onClick={() => {
            onDismiss();
          }}
        >
          بعدا نظر می‌دهم
        </button>
      </div>
    </>
  );
};
